__turbopack_context__.v({
  "icon": "style-module-scss-module__6M4ljW__icon",
  "listing-detail": "style-module-scss-module__6M4ljW__listing-detail",
  "row": "style-module-scss-module__6M4ljW__row",
});
